import { render, staticRenderFns } from "./_taskAttachment.vue?vue&type=template&id=c86d7916&scoped=true"
import script from "./_taskAttachment.vue?vue&type=script&lang=js"
export * from "./_taskAttachment.vue?vue&type=script&lang=js"
import style0 from "./_taskAttachment.vue?vue&type=style&index=0&id=c86d7916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d7916",
  null
  
)

export default component.exports